import { Link } from 'react-router-dom';
import { siteInfo, categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <h4 className="font-heading text-2xl mb-4">{siteInfo.name}</h4>
            <p className="text-foreground-400 text-sm leading-relaxed mb-6 max-w-md">
              {siteInfo.description}
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line text-lg"></i>
              </a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-sm font-medium mb-4 text-background-50">热门分类</h4>
            <div className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="block text-foreground-400 text-sm hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div className="lg:col-span-4">
            <h4 className="text-sm font-medium mb-4 text-background-50">联系我们</h4>
            <div className="space-y-2.5 text-foreground-400 text-sm">
              <p className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                {siteInfo.email}
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                {siteInfo.phone}
              </p>
              <p className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5"></i>
                <span>{siteInfo.address}</span>
              </p>
            </div>
            <div className="mt-6">
              <Link
                to="/about"
                className="text-sm text-primary-400 hover:text-primary-300 transition-colors cursor-pointer"
              >
                了解更多关于我们 →
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} {siteInfo.name}. 保留所有权利。
          </div>
          <div className="flex items-center gap-5">
            <a href="#" className="text-foreground-500 text-xs hover:text-foreground-300 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-foreground-500 text-xs hover:text-foreground-300 transition-colors cursor-pointer whitespace-nowrap">使用条款</a>
            <a href="#" className="text-foreground-500 text-xs hover:text-foreground-300 transition-colors cursor-pointer whitespace-nowrap">DMCA</a>
          </div>
        </div>
      </div>
    </footer>
  );
}